<mat-icon class="sync" *ngIf="acting">sync</mat-icon>
<tyt-follow-icon
  *ngIf="!acting"
  [type]="type"
  [id]="id"
  [followed]="isFollowed"
  [followedIcon]="followedIcon"
  [unfollowedIcon]="unfollowedIcon"
  ></tyt-follow-icon>